<template>
    <div>
        <div class="modal-header">
            <button type="button" class="close" @click="hideModal()" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
                {{day.date | format_date}} ({{day.date | format_date('dddd')| capitalize}})
                - {{plan.time}} {{plan.name}}
            </h4>
        </div>
        <div class="modal-body">
            <div class="navigation">
                <div class="navigation--prev">
                    <div v-show="schema.getPrevNonEmptyDay(day.id)">
                        <button @click="showPrevDay" class="btn btn-success btn-sm" v-tooltip="'Poprzedni dzień'">
                            <i class="fa fa-angle-double-left"></i>
                        </button>
                    </div>
                    <div v-show="day.getPrevPlan(plan.id)">
                        <button @click="showPrevPlan" class="btn btn-success btn-sm" v-tooltip="'Poprzedni posiłek'">
                            <i class="fa fa-angle-left"> </i>
                        </button>
                    </div>
                </div>
                <div class="navigation--next">
                    <div v-show="day.getNextPlan(plan.id)">
                        <button @click="showNextPlan" class="btn btn-success btn-sm" v-tooltip="'Następny posiłek'">
                            <i class="fa fa-angle-right"></i>
                        </button>
                    </div>
                    <div v-show="schema.getNextNonEmptyDay(day.id)">
                        <button @click="showNextDay" class="btn btn-success btn-sm" v-tooltip="'Następny dzień'">
                            <i class="fa fa-angle-double-right"></i>
                        </button>
                    </div>
                </div>
            </div>

            <table class="table table-bordered table-condensed manage-meals-products-and-foods-table">
                <tbody>
                <tr>
                    <th class="full-width">Nazwa</th>
                    <th class="text-center number__select__col">Ilość</th>
                    <th class="text-center nutrient__col" title="Energia">Kcal</th>
                    <th class="text-center nutrient__col" title="Węglowodany">W</th>
                    <th class="text-center nutrient__col" title="Białko">B</th>
                    <th class="text-center nutrient__col" title="Tłuszcze">T</th>
                    <th class="text-center nutrient__col" title="Błonnik">Bł</th>
                    <th style="min-width: 40px;"></th>
                </tr>
                <tr v-show="plan.products.length">
                    <th colspan="9" class="text-center">Produkty</th>
                </tr>
                <tr v-for="product in plan.products">
                    <td>
                        {{product.name}}
                        <span id="unlike-product" class="label label-warning" :class="{hidden: !product.disliked}"
                              v-tooltip="'Produkt jest nielubiany przez pacjenta'">
                                <i class="fa fa-thumbs-down"></i>
                            </span>

                        <span id="allergy-product" class="label label-danger" :class="{hidden: !product.allergen}"
                              v-tooltip="'Produkt w tym daniu jest alergiczny dla pacjenta'">
                                <i class="fa fa-ban"></i>
                            </span>
                    </td>
                    <td class="text-center">
                        <div class="number__select">
                            <input type="number" v-model="product.portion.amount" min="1"
                                   class="form-control form-control-xs">
                            <select v-model="product.portion.weight" class="form-control form-control-xs">
                                <option v-for="weight in product.weight" :value="weight">
                                    {{weight.unit}}
                                    <span v-if="weight.amount !== 1">
                                    ({{weight.amount}}g)
                                    </span>
                                </option>
                            </select>
                        </div>
                    </td>
                    <td class="text-center">
                        {{product.energyInPortion.amount | round}}
                    </td>
                    <td class="text-center">
                        {{ product.sumNutrientById(CARBO) | round }}
                    </td>
                    <td class="text-center">
                        {{ product.sumNutrientById(PROTEIN) | round }}
                    </td>
                    <td class="text-center">
                        {{ product.sumNutrientById(FATS) | round }}
                    </td>
                    <td class="text-center">
                        {{ product.sumNutrientById(FIBER) | round }}
                    </td>
                    <td class="text-center">
                      <permission-tooltip
                          :permission="hasPermission('creator_products_replace')"
                          :tooltip="{top: true, bottom: false, attach: false}"
                      >
                          <span title="Zamień produkt"
                                @click="replaceProduct(product)"
                                role="button">
                            <i class="fa fa-refresh"
                               :class="{
                              'text-green':hasPermission('creator_products_replace'),
                              'text-gray':!hasPermission('creator_products_replace'),
                            }"
                            ></i>
                          </span>
                      </permission-tooltip>
                      <span @click="removeProduct(product.id)" title="Usuń produkt" role="button">
                            <i class="fa fa-times text-red"></i>
                        </span>
                    </td>
                </tr>

                <tr v-show="plan.foods.length">
                    <th colspan="9" class="text-center">Dania</th>
                </tr>

                <tr v-for="food in plan.foods">
                    <td>
                        <span v-bind:class="food.isMultiPortionFood() ? getMultiPortionFoodColorClass(food) : ''">{{food.name}}</span>

                        <span :class="{hidden: !food.repeating.length > 0}"
                              class="label label-default"
                              v-tooltip="repeatedFoods(food)"><i
                                class="fa fa-repeat"></i></span>

                        <span class="label label-warning" :class="{hidden: !food.hasDisliked()}"
                              v-tooltip="'Produkt w tym daniu jest nielubiany przez pacjenta'">
                            <i class="fa fa-thumbs-down"></i></span>

                        <span class="label label-danger"
                              :class="{hidden: !food.hasAllergens()}"
                              v-tooltip="'Produkt w tym daniu jest alergiczny dla pacjenta'">
                            <i class="fa fa-ban"></i></span>

                    </td>
                    <td>
                        <input type="number"
                               :min="getPortionAmountMin(food)"
                               :step="getPortionAmountStep(food)"
                               :max="getPortionAmountMax(food)"
                               v-bind:value="food.portion.amount"
                               v-on:input="getPortionAmountOnInputListener(food, $event)"
                               v-on:change="getPortionAmountOnChangeListener(food, $event)"
                               class="form-control form-control-xs portion-amount__input">
                        <span v-if="food.isMultiPortionFood()">x porcja</span>
                    </td>
                    <td class="text-center">
                        {{food.calculateEnergy().amount | round}}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(CARBO) | round }}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(PROTEIN) | round }}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(FATS) | round }}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(FIBER) | round }}
                    </td>
                    <td class="text-center">
                        <span @click="editFood(food.id)" role="button" title="Edytuj danie">
                            <i class="fa fa-edit text-green"></i>
                        </span>
                        <span @click="removeFood(food.id)" role="button" title="Usuń danie">
                            <i class="fa fa-times text-red"></i>
                        </span>
                    </td>
                </tr>
                <tr id="manage-meal-no-products-and-foods"
                    v-show="plan.products.length === 0 && plan.foods.length === 0">
                    <td colspan="9" class="text-center">Brak produktów i dań</td>
                </tr>
                <tr v-show="(plan.products.length > 1 || plan.foods.length > 1) || (plan.products.length && plan.foods.length) ">
                    <th colspan="2"></th>
                    <th class="text-center">{{plan.totalEnergy.amount | round }}</th>
                    <th class="text-center">{{plan.sumNutrientById(CARBO) | round }}</th>
                    <th class="text-center">{{plan.sumNutrientById(PROTEIN) | round }}</th>
                    <th class="text-center">{{plan.sumNutrientById(FATS) | round }}</th>
                    <th class="text-center">{{plan.sumNutrientById(FIBER) | round }}</th>
                    <th></th>
                </tr>
                <tr>
                    <th colspan="2" class="text-right">
                        WW
                    </th>
                    <th class="text-center">
                        {{plan.sumNutrientById(WW) | round }}
                    </th>
                    <th colspan="4"></th>
                </tr>
                <tr>
                    <th colspan="2" class="text-right">
                        WBT
                    </th>
                    <th class="text-center">
                        {{plan.sumNutrientById(WBT) | round }}
                    </th>
                    <th colspan="4"></th>
                </tr>
                <tr>
                    <th colspan="2" class="text-right">
                        Ładunek glikemiczny
                    </th>
                    <th class="text-center">
                        {{plan.calculateGlicemicLoad() | round }}
                    </th>
                    <th colspan="4"></th>
                </tr>
                <tr>
                  <th colspan="2" class="text-right">
                    Indeks glikemiczny
                  </th>
                  <th class="text-center">
                    {{plan.calculateGlicemicIndex() | round }}
                  </th>
                  <th colspan="4"></th>
                </tr>
                <tr>
                  <th colspan="2" class="text-right">
                    <a @click="showModal({
                      component: 'plan-summary',
                      data: {
                        plan: plan,
                        dayDate: day.date
                      },
                      options: {large: true}
                    })" role="button" title="Pozostałe wartości odżywcze">Pozostałe</a>
                  </th>
                  <th colspan="5"></th>
                </tr>
                </tbody>
            </table>
            <div class="row">
              <div class="col-xs-12">
                <v-alert class="mb-20" type="success" :value="productReplaced">
                  Produkt został zamieniony.
                </v-alert>
              </div>
            </div>
            <div class="row">
                <div class="col-xs-8 col-xs-offset-2">
                    <div class="text-center">
                        <p>Dodaj <label>Produkt</label> lub <label>Danie</label> do posiłku:</p>
                    </div>
                </div>
            </div>
            <div class="row mb-20">
                <div class="col-xs-4 col-xs-offset-2 text-center">
                    <p-radio name="type" type="radio" value="product" class="p-default p-round" color="success-o"
                             @change="show('product')" :checked="type === 'product'"><span
                            class="text-bold">Produkt</span>
                    </p-radio>
                </div>
                <div class="col-xs-4 text-center">
                    <p-radio name="type" value="food" class="p-default p-round" color="success-o"
                             @change="show('food')"
                             :checked="type === 'food'"><span class="text-bold">Danie</span>
                    </p-radio>
                </div>
            </div>

            <div v-if="type === 'food'">
                <div class="row mb-20">
                    <div class="col-md-10 col-md-offset-1">
                        <search-select key="food-select" @item-selected="displayFood"
                                       ref="foodSelect"
                                       :endpoint="searchFoodEndpoint"
                                       placeholder="Szukaj dań"></search-select>
                    </div>
                </div>
                <div v-if="selected">

                    <table class="table table-bordered table-condensed">
                        <tbody>
                        <tr>
                            <th class="full-width">Nazwa</th>
                            <th class="text-center number__select__col">Ilość</th>
                            <th class="text-center nutrient__col" title="Energia">Kcal</th>
                            <th class="text-center nutrient__col" title="Węglowodany">W</th>
                            <th class="text-center nutrient__col" title="Białko">B</th>
                            <th class="text-center nutrient__col" title="Tłuszcze">T</th>
                            <th class="text-center nutrient__col" title="Błonnik">Bł</th>
                            <th style="width: 40px;"></th>
                        </tr>
                        <tr>
                            <td>

                                {{selected.name}}

                                <span v-if="selected.isMultiPortionFood()" class="red--text">
                                        ({{selected.portions}}p.)
                                </span>

                                <span id="repeat-product"
                                      :class="{hidden: !selected.repeating.length > 0}"
                                      class="label label-default"
                                      v-tooltip="repeatedFoods(selected)"><i
                                        class="fa fa-repeat"></i></span>

                                <span class="label label-warning"
                                      :class="{hidden: !selected.hasDisliked()}"
                                      v-tooltip="'Danie zawiera produkty nielubiane przez pacjenta'">
                                    <i class="fa fa-thumbs-down"></i>
                                </span>

                                <span class="label label-danger"
                                      :class="{hidden: !selected.hasAllergens()}"
                                      v-tooltip="'Danie zawiera produkty alergiczne dla pacjenta'">
                                    <i class="fa fa-ban"></i>
                                </span>
                            </td>
                            <td class="text-center">
                                <input type=number
                                       :min="getPortionAmountMinForSelected(selected)"
                                       :step="getPortionAmountStep(selected)"
                                       :max="getPortionAmountMaxForSelected(selected)"
                                       required
                                       v-bind:value="selected.portion.amount"
                                       v-on:input="getPortionAmountOnInputListener(selected, $event)"
                                       v-on:change="getPortionAmountOnChangeListener(selected, $event)"
                                       class="form-control form-control-xs">
                                <span v-if="selected.isMultiPortionFood()">x porcja</span>

                            </td>
                            <td class="text-center">
                                {{ selected.calculateEnergy().amount | round }}
                            </td>
                            <td class="text-center">
                                {{ selected.sumNutrientById(CARBO) | round }}
                            </td>
                            <td class="text-center">
                                {{ selected.sumNutrientById(PROTEIN) | round }}
                            </td>
                            <td class="text-center">
                                {{ selected.sumNutrientById(FATS) | round }}
                            </td>

                            <td class="text-center">
                                {{ selected.sumNutrientById(FIBER) | round }}
                            </td>
                            <td class="text-center">
                                <button @click="addFood(selected)"
                                      class="btn btn-xs btn-success">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="type ==='product'">
                <div class="row mb-20">
                    <div class="col-md-10 col-md-offset-1">
                        <search-select key="product-select"
                                       @item-selected="displayProduct"
                                       ref="productSelect"
                                       :endpoint="configuration.search.product"
                                       placeholder="Szukaj produktów"></search-select>
                    </div>
                </div>
                <div v-if="selected">

                    <table class="table table-bordered table-condensed">
                        <tbody>
                        <tr>
                            <th class="full-width">Nazwa</th>
                            <th class="text-center number__select__col">Ilość</th>
                            <th class="text-center nutrient__col" title="Energia">Kcal</th>
                            <th class="text-center nutrient__col" title="Węglowodany">W</th>
                            <th class="text-center nutrient__col" title="Białko">B</th>
                            <th class="text-center nutrient__col" title="Tłuszcze">T</th>
                            <th class="text-center nutrient__col" title="Błonnik">Bł</th>
                            <th style="width: 40px;"></th>
                        </tr>
                        <tr>
                            <td>

                                {{selected.name}}

                                <span class="label label-warning"
                                      :class="{hidden: !selected.disliked}"
                                      v-tooltip="'Produkt jest nielubiany przez pacjenta'">
                                    <i class="fa fa-thumbs-down"></i>
                                </span>
                                <span class="label label-danger"
                                      :class="{hidden: !selected.allergen}"
                                      v-tooltip="'Produkt jest alergiczny dla pacjenta'">
                                    <i class="fa fa-ban"></i></span>
                            </td>
                            <td>
                                <div class="number__select">
                                    <input type="number" min="1" required v-model="selected.portion.amount"
                                           class="form-control form-control-xs">
                                    <select v-model="selected.portion.weight" class="form-control form-control-xs">
                                        <option v-for="weight in selected.weight" v-bind:value="weight">
                                            {{weight.unit}}
                                            <span v-if="weight.amount !== 1">
                                            ({{weight.amount}}g)
                                            </span>
                                        </option>
                                    </select>
                                </div>
                            </td>

                            <td class="text-center">
                                {{selected.energyInPortion.amount | round}}
                            </td>
                            <td class="text-center">
                                {{selected.sumNutrientById(CARBO) | round}}
                            </td>
                            <td class="text-center">
                                {{selected.sumNutrientById(PROTEIN) | round}}
                            </td>
                            <td class="text-center">
                                {{selected.sumNutrientById(FATS) | round}}
                            </td>
                            <td class="text-center">
                                {{selected.sumNutrientById(FIBER) | round }}
                            </td>

                            <td class="text-center">
                                <span @click="addProduct(selected)" role="button" title="Dodaj produkt"
                                      class="btn btn-xs btn-success">
                                    <i class="fa fa-plus"></i>
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="foodsWithLeftPortions.length > 0" class="row">
                <div class="col-xs-8 col-xs-offset-2">
                    <div class="text-center text-bold">
                        <p>Dania do wykorzystania</p>
                    </div>
                </div>
            </div>
            <table class="table table-bordered table-condensed manage-meals-products-and-foods-table" v-if="foodsWithLeftPortions.length > 0">
                <tbody>
                <tr>
                    <th class="full-width">Nazwa</th>
                    <th class="text-center number__select__col">Porcje</th>
                    <th class="text-center nutrient__col" title="Energia">Kcal</th>
                    <th class="text-center nutrient__col" title="Węglowodany">W</th>
                    <th class="text-center nutrient__col" title="Białko">B</th>
                    <th class="text-center nutrient__col" title="Tłuszcze">T</th>
                    <th class="text-center nutrient__col" title="Błonnik">Bł</th>
                    <th style="min-width: 40px;"></th>
                </tr>
                <tr v-for="food in foodsWithLeftPortions">
                    <td>
                        <span v-bind:class="food.isMultiPortionFood() ? getMultiPortionFoodColorClass(food) : ''">{{food.name}} ({{food.portions}}p.)</span>

                        <span :class="{hidden: !food.repeating.length > 0}"
                              class="label label-default"
                              v-tooltip="repeatedFoods(food)"><i
                                class="fa fa-repeat"></i></span>

                        <span class="label label-warning" :class="{hidden: !food.hasDisliked()}"
                              v-tooltip="'Produkt w tym daniu jest nielubiany przez pacjenta'">
                            <i class="fa fa-thumbs-down"></i></span>

                        <span class="label label-danger"
                              :class="{hidden: !food.hasAllergens()}"
                              v-tooltip="'Produkt w tym daniu jest alergiczny dla pacjenta'">
                            <i class="fa fa-ban"></i></span>

                    </td>
                    <td class="text-center">
                        <input type="number"
                               :min="getPortionAmountMin(food)"
                               :step="getPortionAmountStep(food)"
                               :max="getPortionAmountMax(food)"
                               v-bind:value="food.portion.amount"
                               v-on:input="getPortionAmountOnInputListener(food, $event, true)"
                               v-on:change="getPortionAmountOnChangeListener(food, $event)"
                               class="form-control form-control-xs">
                    </td>
                    <td class="text-center">
                        {{food.calculateEnergy().amount | round}}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(CARBO) | round }}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(PROTEIN) | round }}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(FATS) | round }}
                    </td>
                    <td class="text-center">
                        {{ food.sumNutrientById(FIBER) | round }}
                    </td>
                    <td class="text-center">
                        <button @click="addMultiPortionFood(food)"
                                class="btn btn-xs btn-success">
                            <i class="fa fa-plus"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="modal-footer">
                <button class="btn btn-default pull-right" @click="hideModal()">Zamknij</button>
                <button class="btn btn-success pull-left" @click="showAdvancedSearch(plan.id)" :disabled="!hasPermission('creator_search_advanced')" >
                    <i class="fa fa-sliders"></i>
                    Zaawansowana wyszukiwarka
                </button>
                <button class="btn btn-success pull-left" @click="createFood">Utwórz danie</button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" type="text/scss">
    .in {
        display: block;
    }

    .navigation {
        display: flex;

        & > div {
            flex: 1;
            margin: 0 0 10px;
        }

        & button {
            margin: 0 2px;
            width: 30px;
            text-align: center;
        }

        &--prev {
            display: flex;
            justify-content: flex-start;
        }

        &--next {
            display: flex;
            justify-content: flex-end;
        }
    }
    .portion-amount__input {
        margin-left: 25%;
    }
    .number__select input {
      max-width: 65px;
    }

    .form-control-xs[type=number] {
      width: 65px;
    }
</style>
<script>

    import {mapGetters, mapMutations, mapState} from 'vuex';
    import {productFactory} from '../../../factory/product.factory';
    import {foodFactory} from '../../../factory/food.factory';
    import {createDateTime, dateFromTimestamp, FORMAT_DATETIME, humanizeDuration} from '../../../utils/dateFormatter';
    import {multiPortionFoodsManager} from "../../../services/MultiPortionFoodsManager";
    import Button from "../../../ux/Button";
    import {copyFood, copyProduct} from "../../../services/CopyMenuDay";
    import {CARBO, FATS, FIBER, PROTEIN, WBT, WW} from "../../../services/NutrientDetailsProvider";
    import {trans} from "../../../app";

    export default {
        components: {Button},
        data() {
            return {
                plan: null,
                day: null,
                type: null,
                query: null,
                selected: null,
                planDate: null,
                foodsWithLeftPortions: [],
                productReplaced: false,
                CARBO: CARBO,
                PROTEIN: PROTEIN,
                FATS: FATS,
                FIBER: FIBER,
                WW: WW,
                WBT: WBT,
            };
        },
        mounted() {
            this.resetComponentSelects();
        },
        computed: {
            ...mapState({
                modalData: state => state.modal.data,
                schema: state => state.menu.schema,
            }),
            ...mapGetters([
                'getDayById',
                'configuration',
                'hasPermission',
            ]),
            searchFoodEndpoint() {
                return this.configuration.search.food + '?date=' + this.day.date;
            },
        },
        methods: {
            ...mapMutations([
                'hideModal',
                'showModal',
                'checkFoodRepetition',
                'removeProductReplacement',
            ]),
            show(type) {
                this.selected = null;
                this.foodsWithLeftPortions = this.getFoodsWithLeftPortions();
                this.type = type;
            },
            addFood(food) {
                const newFood = copyFood(food);
                this.plan.addFood(newFood);
                this.checkFoodRepetition(newFood);
                this.resetSearch(this.$refs.foodSelect);
                this.foodsWithLeftPortions = this.getFoodsWithLeftPortions();
                this.selected = food;
            },
            addMultiPortionFood(food) {
              const newFood = copyFood(food);
              multiPortionFoodsManager.addMultiPortionFoodToPlan(newFood, this.schema, this.plan);
              this.checkFoodRepetition(newFood);
              this.foodsWithLeftPortions = this.getFoodsWithLeftPortions();
            },
            removeFood(foodId) {
              this.$confirmDanger(trans('app.creator.foods.remove')).then(() => {
                const food = this.plan.getFood(foodId);

                if (food.isMultiPortionFood()) {
                  multiPortionFoodsManager.removeMultiPortionFood(food, this.schema);
                }

                this.plan.removeFood(foodId);

                this.foodsWithLeftPortions = this.getFoodsWithLeftPortions();
              }).catch((error) => {
                this.sentryCaptureException(error);
              });
            },
            editFood(foodId) {
                this.showModal(
                    {
                        component: 'edit-food-modal',
                        data: {dayId: this.day.id, planId: this.plan.id, foodId: foodId},
                        options: {large: true},
                    },
                );
            },
            createFood() {
                this.showModal({
                    component: 'create-food-modal',
                    data: {dayId: this.day.id, planId: this.plan.id},
                    options: {large: true},
                });
            },
            displayFood(foodDTO) {
                if (!foodDTO)
                    return;
                this.selected = foodFactory.createFromDto(foodDTO);
                this.checkFoodRepetition(this.selected);
                this.resetComponentSelects();
            },
            addProduct(product) {
                this.plan.addProduct(copyProduct(product));
                this.resetSearch(this.$refs.productSelect);
                this.selected = product;
            },

            removeProduct(productId) {
              this.$confirmDanger(trans('app.creator.products.remove')).then(() => {
                this.plan.removeProduct(productId)
              }).catch((error) => {
                this.sentryCaptureException(error);
              });
            },
            displayProduct(productDTO) {
                if (!productDTO)
                    return;
                this.selected = productFactory.createFromDto(productDTO);
                this.resetComponentSelects();
            },
            showNextPlan() {
                const nextPlan = this.day.getNextPlan(this.plan.id);
                this.showPlanModal(nextPlan.id);
            },
            showPrevPlan() {
                const prevPlan = this.day.getPrevPlan(this.plan.id);
                this.showPlanModal(prevPlan.id);
            },
            showNextDay() {
                const nextDay = this.schema.getNextNonEmptyDay(this.day.id);
                this.showDayModal(nextDay);
            },
            showPrevDay() {
                const prevDay = this.schema.getPrevNonEmptyDay(this.day.id);
                this.showDayModal(prevDay);
            },
            resetSearch(component) {
                if (component)
                    component.reset();
            },
            showPlanModal(planId) {
                this.resetComponentSelects();
                this.showModal(
                    {
                        component: 'search',
                        data: {dayId: this.day.id, planId: planId},
                        options: {large: true},
                    },
                );
            },

            showDayModal(day) {
                this.resetComponentSelects();
                this.showModal(
                    {
                        component: 'search',
                        data: {dayId: day.id, planId: day.plans[0].id},
                        options: {large: true},
                    },
                );
            },
            showAdvancedSearch(planId) {
                this.showModal(
                    {
                        component: 'search-advanced',
                        data: {dayId: this.day.id, planId: planId, isAssignedToUser: this.modalData.isAssignedToUser},
                        options: {fullscreen: true, nodraggable: true, large: true},
                    },
                );
            },

            resetComponentSelects() {
                this.resetSearch(this.$refs.foodSelect);
                this.resetSearch(this.$refs.productSelect);
            },

            repeatedFoods(food) {
                const r = food.repeating.map(occurrence => {
                    const dateOccurred = dateFromTimestamp(occurrence);
                    const diff = dateOccurred.diff(this.planDate);
                    return dateOccurred.format(FORMAT_DATETIME) + ' - ' + humanizeDuration(diff);
                });

                return r.join('<br>');
            },
            getPortionAmountMin() {
                return 0.5;
            },
            getPortionAmountMinForSelected() {
                return 1;
            },
            getPortionAmountStep(food) {
                return food.isMultiPortionFood() ? 0.5 : 0.1;
            },
            getPortionAmountOnInputListener(food, $event, forFoodWithLeftPortions = false) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (food.isMultiPortionFood()) {
                    if (inputValue >= minValue && inputValue <= maxValue) {
                        food.portion.amount = inputValue;
                    } else if (inputValue < minValue) {
                        food.portion.amount = minValue;
                    } else if (inputValue > maxValue) {
                        food.portion.amount = maxValue;
                    }
                } else {
                    if (inputValue >= minValue) {
                        food.portion.amount = inputValue;
                    } else if (inputValue < minValue) {
                        food.portion.amount = minValue;
                    }
                }

                if (food.isMultiPortionFood() && forFoodWithLeftPortions === false) {
                    this.foodsWithLeftPortions = this.getFoodsWithLeftPortions();
                }
            },
            getPortionAmountOnChangeListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (food.isMultiPortionFood()) {
                    if (inputValue >= minValue && inputValue <= maxValue) {
                        $event.target.value = inputValue;
                    } else if (inputValue < minValue) {
                        $event.target.value = $event.target.min;
                    } else if (inputValue > maxValue) {
                        $event.target.value = $event.target.max;
                    }
                } else {
                    if (inputValue >= minValue) {
                        $event.target.value = inputValue;
                    } else if (inputValue < minValue) {
                        $event.target.value = $event.target.min;
                    }
                }
            },
            getPortionAmountMax(food) {
                if (food.isMultiPortionFood()) {
                    const leftPortionsOfFood = multiPortionFoodsManager.getLeftPortionsOfFood(food, this.schema);
                    return food.portion.amount + leftPortionsOfFood;
                }
            },
            getPortionAmountMaxForSelected(food) {
                if (food.isMultiPortionFood()) {
                    return food.portions;
                }
            },
            getFoodsWithLeftPortions() {
                return multiPortionFoodsManager.getFoodsWithLeftPortions(this.schema);
            },
            getMultiPortionFoodColorClass(food) {
                if (food.isMultiPortionFood() === false) {
                    return '';
                }

                return multiPortionFoodsManager.getMultiPortionFoodColor(food, this.schema);
            },
            replaceProduct(product) {
            if (!this.hasPermission('creator_products_replace')) {
              return;
            }
            this.showModal({
              component: 'replace-search-product-modal',
              data: {
                productToReplace: product,
                food: null,
                plan: this.plan,
                day: this.day
              },
            });
          }
        },
        watch: {
            modalData: {
                immediate: true,
                handler: function (data) {
                    if (!data) return;
                    this.day = this.getDayById(data.dayId);
                    this.plan = this.day.getPlan(data.planId);
                    if (data.product) {
                      this.removeProductReplacement(data.product);
                    }
                    this.resetComponentSelects();

                    this.planDate = Object.freeze(createDateTime(this.day.date, this.plan.time));
                    if (data.productReplaced){
                      this.productReplaced = data.productReplaced;
                    }
                },
            },
        },
    };
</script>
